module.exports = __webpack_public_path__ + "static/media/usa.fe76e7cf.jpg";